<template>
  <div>
    <top-navbar></top-navbar>
    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link
        ><span class="pfimg3"><i class="fa fa-angle-right"></i></span
        ><span class="decoration">Documents</span
        ><span class="pfimg3"><i class="fa fa-angle-right"></i></span
        ><router-link class="decoration" to="/document/index"
          >Manage Documents</router-link
        ><span class="pfimg3"><i class="fa fa-angle-right"></i></span
        ><router-link
          class="decoration"
          :to="'/document/view?id=' + $route.query.id"
          >{{ form.job_title || "View" }}</router-link
        ><span class="pfimg3"><i class="fa fa-angle-right"></i></span
        ><span class="decoration">update</span>
      </h6>
      <div class="container-fluid">
        <div class="card bdr-rad2 mt-1 shadow p-2">
          <div class="card-body">
            <div v-if="message" class="alert alert-success py-2">
              {{ message }}
            </div>
            <div v-if="errorMessage" class="alert alert-danger py-2">
              {{ errorMessage }}
            </div>
            <div v-if="isLoading" class="text-center">
              <div class="spinner-border text-primary"></div>
            </div>
            <form v-else @submit.prevent="updateDocument">
              <div class="row mb-3 mx-0">
                <div class="col-md-3">
                  <label class="custom-label"
                    >Document Title <span class="text-danger">*</span></label
                  ><input
                    v-model="form.job_title"
                    required
                    class="form-control form-control-sm bdr-rad font-size_def"
                  />
                </div>
                <div class="col-md-3">
                  <label class="custom-label">People</label
                  ><input
                    :value="form.employee"
                    readonly
                    class="form-control form-control-sm bdr-rad bg-light font-size_def"
                  />
                </div>
                <div class="col-md-3">
                  <label class="custom-label"
                    >Document Type <span class="text-danger">*</span></label
                  ><input
                    v-model="form.document_type"
                    required
                    class="form-control form-control-sm bdr-rad font-size_def"
                  />
                </div>
              </div>
              <div class="card custom_bdr_rds">
                <div class="card-body custom_bdr_rds">
                  <h6 class="purchitem mb-2">
                    <b>Mandatory Document Metadata</b>
                  </h6>
                  <div class="row g-2">
                    <div
                      v-for="field in firstRow"
                      :key="field.key"
                      class="col-md-3"
                    >
                      <label class="custom-label"
                        >{{ field.label }}
                        <span class="text-danger">*</span></label
                      ><select
                        v-if="field.key === 'privacy_level'"
                        v-model="form[field.key]"
                        required
                        class="form-control form-control-sm bdr-rad"
                      >
                        <option value="">Select Privacy</option>
                        <option>Public</option>
                        <option>Internal</option>
                        <option>Confidential</option>
                        <option>Restricted</option>
                      </select><input
                        v-else
                        v-model="form[field.key]"
                        required
                        class="form-control form-control-sm bdr-rad"
                      />
                    </div>
                  </div>
                  <div class="row g-2">
                    <div
                      v-for="field in secondRow"
                      :key="field.key"
                      class="col-md-3"
                    >
                      <label class="custom-label"
                        >{{ field.label }}
                        <span class="text-danger">*</span></label
                      ><select
                        v-if="field.key === 'privacy_level'"
                        v-model="form[field.key]"
                        required
                        class="form-control form-control-sm bdr-rad"
                      >
                        <option value="">Select Privacy</option>
                        <option>Public</option>
                        <option>Internal</option>
                        <option>Confidential</option>
                        <option>Restricted</option></select
                      ><input
                        v-else
                        v-model="form[field.key]"
                        required
                        class="form-control form-control-sm bdr-rad"
                      />
                    </div>
                  </div>
                  <div class="row g-2">
                    <div class="col-md-3">
                      <label class="custom-label">Permission Group</label
                      ><input
                        v-model="form.permission_group"
                        class="form-control form-control-sm bdr-rad"
                      />
                    </div>
                    <div class="col-md-3">
                      <label class="custom-label">Publisher</label
                      ><input
                        :value="form.publisher"
                        readonly
                        class="form-control form-control-sm bdr-rad bg-light"
                      />
                    </div>
                    <div class="col-md-3">
                      <label class="custom-label">Status</label
                      ><input
                        :value="form.document_status"
                        readonly
                        class="form-control form-control-sm bdr-rad bg-light"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="card custom_bdr_rds mt-3">
                <div class="card-body custom_bdr_rds">
                  <h6 class="purchitem mb-2"><b>Document Files and Links</b></h6>
                  <div class="table-responsive mb-1">
                    <table style="font-size: small" class="table table-sm table-hover">
                      <thead class="background_color2">
                        <tr class="custom-label2"><th>#</th><th>File Upload</th><th>Document Link</th><th>Actions</th></tr>
                      </thead>
                      <tbody>
                        <tr v-for="(detail, index) in form.details" :key="'existing-' + index">
                          <td>{{ index + 1 }}</td>
                          <td>
                            <a v-if="detail.file" :href="detail.file" target="_blank">{{ fileName(detail.file) }}</a><span v-else>-</span>
                            <small class="d-block mt-1">Replace File</small>
                            <input type="file" class="form-control form-control-sm bdr-rad" @change="replaceFile($event, detail)" />
                            <small v-if="detail.replacementFile" class="text-success">Replace file selected</small>
                          </td>
                          <td>
                            <small class="d-block">&nbsp;</small>
                            <small class="d-block mt-1 mb-0">Update Link</small>
                            <input v-model="detail.link" type="url" placeholder="Document link" class="form-control form-control-sm bdr-rad mt-1" />
                          </td>
                          <td>-</td>
                        </tr>
                        <tr v-for="(detail, index) in newDetails" :key="detail.key">
                          <td>{{ form.details.length + index + 1 }}</td>
                          <td><input type="file" class="form-control form-control-sm bdr-rad" @change="setFile($event, detail)" /></td>
                          <td><input v-model="detail.link" type="url" placeholder="Document link" class="form-control form-control-sm bdr-rad" /></td>
                          <td class="custom-icon"><b-icon @click="removeDetail(index)" v-if="newDetails.length > 1" class="ms-3 me-3 mt-2" width="8" icon="dash-lg" type="button" scale="2"></b-icon><b-icon @click="addDetail" v-if="index === newDetails.length - 1" class="mt-2" width="8" icon="plus-lg" type="button" scale="2"></b-icon></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end mt-3">
                <router-link
                  to="/document/index"
                  class="btn btn-sm btn-outline-secondary bdr-rad font-size_def mr-2"
                  >Cancel</router-link
                ><button
                  type="submit"
                  class="btn btn-sm btn-outline-primary bdr-rad font-size_def"
                >
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
        <br><br>
      </div>
    </div>
    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from "axios";
import authService from "@/auth.service";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";
export default {
  components: { TopNavbar, ContentFooter },
  data() {
    return {
      token: authService.isLoggedIn(),
      isLoading: true,
      message: "",
      errorMessage: "",
      firstRow: [
        { key: "company", label: "Company" },
        { key: "department", label: "Department" },
        { key: "branch", label: "Branch" },
        { key: "privacy_level", label: "Privacy Level" },
      ],
      secondRow: [
        { key: "project", label: "Project" },
        { key: "partner", label: "Partner" },
        { key: "template", label: "Template" },
      ],
      form: {},
      newDetails: [{ key: Date.now() + Math.random(), file: null, link: "" }],
    };
  },
  mounted() {
    this.loadDocument();
  },
  methods: {
    async loadDocument() {
      try {
        const { data } = await axios.get(
          "/document/view?id=" + this.$route.query.id,
          { headers: { Authorization: "Bearer " + this.token } }
        );
        this.form = {
          ...(data.data || {}),
          details: ((data.data && data.data.details) || []).map((detail) => ({ ...detail, originalLink: detail.link || "" })),
        };
      } catch (error) {
        this.errorMessage = "Unable to load document.";
      } finally {
        this.isLoading = false;
      }
    },
    newDetail() {
      return { key: Date.now() + Math.random(), file: null, link: "" };
    },
    addDetail() {
      this.newDetails.push(this.newDetail());
    },
    removeDetail(index) {
      if (this.newDetails.length > 1) this.newDetails.splice(index, 1);
    },
    setFile(event, detail) {
      detail.file = event.target.files && event.target.files[0] ? event.target.files[0] : null;
    },
    replaceFile(event, detail) {
      this.$set(detail, "replacementFile", event.target.files && event.target.files[0] ? event.target.files[0] : null);
    },
    fileName(file) {
      return String(file || "").split("/").pop();
    },
    async updateDocument() {
      try {
        const formData = new FormData();
        const hasFileChanges = this.form.details.some((detail) => detail.replacementFile || detail.link !== detail.originalLink) || this.newDetails.some((detail) => detail.file || (detail.link || "").trim());
        const details = hasFileChanges
          ? [
              ...this.form.details.map((detail) => ({ link: detail.link || "", existing_file: detail.file || "" })),
              ...this.newDetails.filter((detail) => detail.file || (detail.link || "").trim()).map((detail) => ({ link: detail.link || "" })),
            ]
          : [];
        formData.append("payload", JSON.stringify({ ...this.form, replace_details: hasFileChanges, details }));
        this.form.details.forEach((detail, index) => {
          if (detail.replacementFile) formData.append("assignment_files[" + index + "]", detail.replacementFile);
        });
        this.newDetails.forEach((detail, index) => {
          if (detail.file || (detail.link || "").trim()) {
            if (detail.file) formData.append("assignment_files[" + (this.form.details.length + index) + "]", detail.file);
          }
        });
        const { data } = await axios.post("/document/update?id=" + this.$route.query.id, formData, { headers: { Authorization: "Bearer " + this.token } });
        this.message = data.message;
        setTimeout(() => this.$router.push("/document/view?id=" + this.$route.query.id), 500);
      } catch (error) {
        this.errorMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          "Unable to update document.";
      }
    },
  },
};
</script>
